// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  initializeAuth,
  getAuth,
  browserSessionPersistence,
} from "firebase/auth";

const firebaseConfig = {
  // Your actual Firebase config details here
  apiKey: "AIzaSyB0dPhUC44xv_byhi5o0aRN3GagyYQpB_o",
  authDomain: "ptu-db.firebaseapp.com",
  projectId: "ptu-db",
  storageBucket: "ptu-db.firebasestorage.app",
  messagingSenderId: "690192216408",
  appId: "1:690192216408:web:e71bfb087611ec7792b52d",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Initialize auth with session persistence
const auth = getAuth(app);
auth.setPersistence(browserSessionPersistence);

export { db, auth };
